import React from "react";
import { Link } from "react-router-dom";

export default function BlogCard({ slug, image, titulo, data, desc }) {
  const apiUrl = process.env.REACT_APP_STRAPI_URL;
  return (
    <Link
      to={`/notas/${encodeURIComponent(slug)}`}
      className="flex flex-col justify-center items-center w-[300px] h-[400px] group  "
      tabIndex={0}
      aria-label={`Ver detalle del blog: ${titulo}`}
      style={{ textDecoration: "none" }}
    >
      <div className="relative overflow-hidden rounded-xl w-[300px] h-[200px] shadow-md dark:bg-sidom-blue">
        <img
          src={`${apiUrl}${image}`}
          className="w-[300px] h-[200px] object-cover"
          alt={titulo || "Blog image"}
        />
      </div>
      <div className="p-4 flex flex-col h-[280px] w-full">
        <div className="h-[80px] overflow-hidden">
          <span className="text-lg font-bold group-hover:text-sidom-orange duration-500">
            {titulo}
          </span>
        </div>
        <div className="h-[60px] overflow-hidden">
          <p className="text-sidom-blue dark:text-sidom-light line-clamp-2 text-sm mt-3">
            {desc}
          </p>
        </div>
        <div className="mt-3">
          <span className="hover:text-orange-500 group-hover:text-orange-500">
            Leer más <i className="mdi mdi-arrow-right align-middle"></i>
          </span>
        </div>
      </div>
    </Link>
  );
}
